module.exports = __webpack_public_path__ + "img/icon-home-active.2e021c4f.svg";